// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetInfo (params?: {}): Promise<Dict>;
    publicGetInfoFees (params?: {}): Promise<Dict>;
    publicGetInfoPrices (params?: {}): Promise<Dict>;
    publicGetKline (params?: {}): Promise<Dict>;
    publicGetKlineMark (params?: {}): Promise<Dict>;
    publicGetBook (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<Dict>;
    publicGetFundingRateHistory (params?: {}): Promise<Dict>;
    publicGetLoanPool (params?: {}): Promise<Dict>;
    publicGetAccount (params?: {}): Promise<Dict>;
    publicGetAccountLoan (params?: {}): Promise<Dict>;
    publicGetAccountSettings (params?: {}): Promise<Dict>;
    publicGetPositions (params?: {}): Promise<Dict>;
    publicGetTradesHistory (params?: {}): Promise<Dict>;
    publicGetFundingHistory (params?: {}): Promise<Dict>;
    publicGetPortfolio (params?: {}): Promise<Dict>;
    publicGetAccountBalanceHistory (params?: {}): Promise<Dict>;
    publicGetAccountSpotBalanceHistory (params?: {}): Promise<Dict>;
    publicGetAccountSpotAssetDepositHistory (params?: {}): Promise<Dict>;
    publicGetAccountSpotAssetWithdrawHistory (params?: {}): Promise<Dict>;
    publicGetAccountSpotAssetWithdrawPending (params?: {}): Promise<Dict>;
    publicGetOrders (params?: {}): Promise<Dict>;
    publicGetOrdersHistory (params?: {}): Promise<Dict>;
    publicGetOrdersHistoryById (params?: {}): Promise<Dict>;
    publicGetSpotAssets (params?: {}): Promise<Dict>;
    publicGetSpotAssetsBridgeInfo (params?: {}): Promise<Dict>;
    publicGetSpotAssetsBridgeParametersSymbol (params?: {}): Promise<Dict>;
    publicGetLakeList (params?: {}): Promise<Dict>;
    publicGetAccountBuilderCodesApprovals (params?: {}): Promise<List>;
    privatePostAccountLeverage (params?: {}): Promise<Dict>;
    privatePostAccountMargin (params?: {}): Promise<Dict>;
    privatePostAccountWithdraw (params?: {}): Promise<Dict>;
    privatePostAccountSettingsAutoLendDisabled (params?: {}): Promise<Dict>;
    privatePostAccountSettingsSpot (params?: {}): Promise<Dict>;
    privatePostAccountSpotAssetWithdraw (params?: {}): Promise<Dict>;
    privatePostAccountSubaccountCreate (params?: {}): Promise<Dict>;
    privatePostAccountSubaccountList (params?: {}): Promise<Dict>;
    privatePostAccountSubaccountTransfer (params?: {}): Promise<Dict>;
    privatePostAccountSubaccountSpotAssetTransfer (params?: {}): Promise<Dict>;
    privatePostPositionsAddIsolatedMargin (params?: {}): Promise<Dict>;
    privatePostOrdersCreate (params?: {}): Promise<Dict>;
    privatePostOrdersCreateMarket (params?: {}): Promise<Dict>;
    privatePostOrdersStopCreate (params?: {}): Promise<Dict>;
    privatePostPositionsTpsl (params?: {}): Promise<Dict>;
    privatePostOrdersCancel (params?: {}): Promise<Dict>;
    privatePostOrdersCancelAll (params?: {}): Promise<Dict>;
    privatePostOrdersStopCancel (params?: {}): Promise<Dict>;
    privatePostOrdersEdit (params?: {}): Promise<Dict>;
    privatePostOrdersBatch (params?: {}): Promise<Dict>;
    privatePostAccountBuilderCodesApprove (params?: {}): Promise<Dict>;
    privatePostAccountBuilderCodesRevoke (params?: {}): Promise<Dict>;
    privatePostAgentBind (params?: {}): Promise<Dict>;
    privatePostAccountApiKeysCreate (params?: {}): Promise<Dict>;
    privatePostAccountApiKeysRevoke (params?: {}): Promise<Dict>;
    privatePostAccountApiKeys (params?: {}): Promise<Dict>;
    privatePostLakeAddBlacklist (params?: {}): Promise<Dict>;
    privatePostLakeAddMaxLeverage (params?: {}): Promise<Dict>;
    privatePostLakeAddWhitelist (params?: {}): Promise<Dict>;
    privatePostLakeClaimManager (params?: {}): Promise<Dict>;
    privatePostLakeClaimReferralCode (params?: {}): Promise<Dict>;
    privatePostLakeCreate (params?: {}): Promise<Dict>;
    privatePostLakeDeposit (params?: {}): Promise<Dict>;
    privatePostLakeRemoveBlacklist (params?: {}): Promise<Dict>;
    privatePostLakeRemoveMaxLeverage (params?: {}): Promise<Dict>;
    privatePostLakeRemoveWhitelist (params?: {}): Promise<Dict>;
    privatePostLakeUpdateDepositCap (params?: {}): Promise<Dict>;
    privatePostLakeWithdraw (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
